import request from "@/common/request";
import { MensagemAssistenteIA } from "@/models/assistente-ia";
import { AxiosRequestConfig } from "axios";

const basePath = '/openia/assistente'

export const perguntar = (params?: any, config?: AxiosRequestConfig): Promise<string> =>
	request.get(`${basePath}`, { params, ...config })

export const buscarMensagens = (config?: AxiosRequestConfig): Promise<MensagemAssistenteIA[]> =>
	request.get(`${basePath}/mensagens`, { ...config })

export const criarNovaThread = (): Promise<void> =>
	request.post(`${basePath}/thread`)